module.exports = __webpack_public_path__ + "static/media/daniel.53c6d8cc.png";